module.exports = __webpack_public_path__ + "imgs/gpb2x.f62d04ed.webp";